import { AgGridReact } from "ag-grid-react";
import { useState, useRef, useEffect } from "react";
import { Container } from "react-bootstrap";
import GridComponent from "../../../../components/grid/gridComponent";
import PageTitle from "../../../shared/layout/pageTitle/pageTitle";
import { useAppDispatch } from "../../../../store/hooks";
import CurrencyConverter from "../../../shared/currencyConverter/CurrencyConverter";
import getFiles from "../../../shared/csvDownload/csvDownload";
import {
  COLUMN_CONFIG_REPORT_NAMES,
  formatDatePipe,
  formateIds,
  gridAlignment,
  visibleColumnNames,
} from "../../../../interface/comman.constant";
import { toast } from "react-toastify";
import { getTableFields } from "../../../../helpers/getTableFields";
import { useSelector } from "react-redux";
import { getDrugLiquidationOrderHistoryReport } from "../../../../store/api/apiSlice";
import { useNavigate } from "react-router-dom";
import { useUserSettings } from "../../../../helpers/hooks/useUserSettings";
import { showConfigColumns } from "../../../../helpers/getSortedVisibleCols";

function DrugLiquidationOrderHistory() {
  const gridRef = useRef<AgGridReact>(null);
  const myRef = useRef<any>();
  const [gridApi, setGridApi] = useState<any>(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const userAccounts =
    useSelector((state: any) => state?.accounts?.chosenIds[0]) || [];
  const refreshPage =
    useSelector((state: any) => state?.accounts?.refreshPage) || false;
  const [gridData, setGridData] = useState({
    sortOrder: "",
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: [100, 200, 300],
    pageSize: 100,
    page: 1,
    globalSearch: "",
    totalAmount: "",
    isForExcel: false,
    sortField: "",
    csvName: "DrugLiquidationOrderHistory.csv",
    URL: "Reports/GetDrugLiquidationOrderHistory",
    filterOptions: [],
  });

  const columnItems = [{
    headerName: "Sales Order",
    headerTooltip: "Sales Order",
    tooltipShowDelay: 0,
    field: "salesOrder",
    filter: "agTextColumnFilter",
    filterParams: {
      buttons: ["reset"],
      debounceMs: 1000,
      suppressAndOrCondition: true,
    },
    menuTabs: ["filterMenuTab"],
    hide: false,
    cellStyle: { cursor: "pointer" },
    comparator: customComparator, cellRenderer: function (params: any) {
      return (
        <div
          className={`text-link`}
          onClick={(e) => {
            localStorage.setItem(
              "DrugLiquidationRow",
              JSON.stringify(params.data)
            );
            navigate(
              "/reports/drug-liquidation/" + params.data.orderNumber
            );
          }}
        >
          {params.data.salesOrder}
        </div>
      );
    },
  },
  {
    headerName: "Account Code",
    field: "customerId",
    headerTooltip: "AccountCode#",
    tooltipShowDelay: 0,
    filter: "agTextColumnFilter",
    filterParams: {
      buttons: ["reset"],
      debounceMs: 1000,
      suppressAndOrCondition: true,
    },
    menuTabs: ["filterMenuTab"],
    hide: false,
    comparator: customComparator,
    minWidth: 180,
  },
  {
    headerName: "Account Name",
    field: "accountName",
    headerTooltip: "Account Name",
    tooltipShowDelay: 0,
    filter: "agTextColumnFilter",
    filterParams: {
      buttons: ["reset"],
      debounceMs: 1000,
      suppressAndOrCondition: true,
    },
    menuTabs: ["filterMenuTab"],
    hide: false,
    comparator: customComparator,
  }, {
    headerName: "Service Date",
    field: "serviceDate",
    hide: false,
    comparator: customComparator,
    filter: "agTextColumnFilter",
    menuTabs: ["filterMenuTab"],
    filterParams: {
      suppressAndOrCondition: true,
      buttons: ["reset"],
      debounceMs: 1000,
    },
  }, {
    headerName: "Process Date",
    field: "processedDate",
    hide: false,
    comparator: customComparator,
    filter: "agDateColumnFilter",
    menuTabs: ["filterMenuTab"],
    filterParams: {
      suppressAndOrCondition: true,
      buttons: ["reset"],
      debounceMs: 1000,
    },
  }, {
    headerName: "Payment Date",
    field: "paymentDate",
    hide: false,
    comparator: customComparator,
    filter: "agDateColumnFilter",
    menuTabs: ["filterMenuTab"],
    filterParams: {
      suppressAndOrCondition: true,
      buttons: ["reset"],
      debounceMs: 1000,
    },
  }, {
    headerName: "Amount",
    headerTooltip: "Amount",
    tooltipShowDelay: 0,
    field: "amount",
    hide: false,
    comparator: customComparator,
    type: gridAlignment.RIGHT,
    filter: "agNumberColumnFilter",
    filterParams: {
      buttons: ["reset"],
      debounceMs: 1000,
      suppressAndOrCondition: true,
    },
    menuTabs: ["filterMenuTab"],
  }, {
    headerName: "Reference Number",
    headerTooltip: "Reference Number",
    tooltipShowDelay: 0,
    field: "referenceNumber",
    filter: "agTextColumnFilter",
    filterParams: {
      buttons: ["reset"],
      debounceMs: 1000,
      suppressAndOrCondition: true,
    },
    menuTabs: ["filterMenuTab"],
    hide: false,
    comparator: customComparator,
  }
  ];

  const { id, dbColumnConfig } = useUserSettings(COLUMN_CONFIG_REPORT_NAMES?.DrugLiquidationOrderHistory);
  const [colDefs, setColDefs] = useState(() => showConfigColumns(columnItems, dbColumnConfig));

  function customComparator() {
    return 0; //means no comparing and no sorting
  }

  const onGridReady = (params: any) => {
    setGridApi(params.api);
  };

  const updateGridData = (k: any, v: any) =>
    setGridData((prev) => ({ ...prev, [k]: v }));

  const popupSave = (event: any, columnValues: any) => {
    event.preventDefault();

    toast.success("Saved Successfully");
    setColDefs(columnValues);
    myRef?.current.handleClose();
    if (gridRef.current) {
      gridRef.current.api.autoSizeAllColumns();
    }
  };

  const DrugLiquidationOrderHistory = async () => {
    try {
      if (gridApi) {
        const dataSource = {
          getRows: (params: any) => {
            let data = {
              PageNumber:
                Math.floor(params.request.startRow / gridData.pageSize) + 1,
              PageSize: gridData.pageSize,
              SortField: params.request.sortModel?.[0]?.colId || "",
              SortDirection: params.request.sortModel?.[0]?.sort === "asc" ? 0 : 1,
              IsForExcel: gridData.isForExcel,
              GlobalSearch: gridData.globalSearch,
              filterOptions: getTableFields(params.request.filterModel),
              CustomerIds: formateIds(userAccounts),
            };
            updateGridData(
              "filterOptions",
              getTableFields(params.request.filterModel)
            );
            dispatch(getDrugLiquidationOrderHistoryReport(data)).then((result: any) => {
              if (result?.payload?.data?.orderHistories?.length === 0) {
                gridApi.showNoRowsOverlay();
                params.success({
                  rowData: [],
                  rowCount: 0,
                });
              } else {
                gridApi!.hideOverlay();
                params.success({
                  rowData: result?.payload?.data?.orderHistories,
                  rowCount: result?.payload?.data?.totalCount,
                });
              }

              updateGridData("totalRows", result?.payload?.data?.totalCount);
              updateGridData(
                "totalAmount",
                CurrencyConverter.format(result?.payload?.data?.totalAmount)
              );
            });
          },
        };
        gridApi.setGridOption("serverSideDatasource", dataSource);
      }
    } catch (error) { }
  };

  useEffect(() => {
    if (gridData.globalSearch) {
      const getData = setTimeout(() => {
        DrugLiquidationOrderHistory();
      }, 2000);

      return () => clearTimeout(getData);
    } else {
      DrugLiquidationOrderHistory();
    }
  }, [
    gridData.page,
    gridData.pageSize,
    gridData.globalSearch,
    gridApi,
    refreshPage,
  ]);

  useEffect(() => {
    if (gridData.isForExcel === true) {
      getFiles(gridData, visibleColumnNames(colDefs), formateIds(userAccounts));
      updateGridData("isForExcel", false);
    }
  }, [gridData.isForExcel]);

  useEffect(() => {
    if (Object.keys(dbColumnConfig).length > 0)
      setColDefs(showConfigColumns(columnItems, dbColumnConfig));
  }, [dbColumnConfig])

  const onSortChanged = ({
    api: { sortController },
  }: {
    api: { sortController: any };
  }): void => {
    const sortModel: any[] = sortController.getSortModel();
    if (sortModel.length > 0) {
      const { colId, sort } = sortModel[0];
      updateGridData("sortOrder", sort === "asc" ? "0" : "1");
      updateGridData("sortField", colId);
    }
  };

  const globalSearch = (e: any) => {
    updateGridData("globalSearch", e.target.value);
  };
  const onExport = (e: any) => {
    updateGridData("isForExcel", true);
  };
  const onClearFilter = () => {
    gridApi!.setFilterModel(null);
    updateGridData("globalSearch", "");
  };
  const paginationChange = () => {
    if (gridApi) {
      updateGridData("pageSize", gridApi.paginationGetPageSize());
    }
  }
  return (
    <Container fluid>
      <PageTitle
        name="Drug Liquidation Order History"
        buttonName="Back"
        routePage="/reports/view-all"
      ></PageTitle>
      <div className="content_body grid-reset">
        <GridComponent
          dbUserReportId={id}
          dbReportName={COLUMN_CONFIG_REPORT_NAMES?.DrugLiquidationOrderHistory}
          dbColumnConfig={dbColumnConfig}
          defaultColumns={columnItems}
          ref={myRef}
          gridRef={gridRef}
          rowData={gridData.rows}
          colDefs={colDefs}
          onGridReady={onGridReady}
          popupSave={popupSave}
          paginationPageSize={gridData.pageSize}
          paginationPageSizeSelector={gridData.rowsPerPageOptions}
          shortOrder={gridData.sortOrder}
          sortChange={onSortChanged}
          globalSearch={globalSearch}
          onExport={onExport}
          gridData={gridData}
          setGridData={setGridData}
          onClearFilter={onClearFilter}
          paginationChange={paginationChange}
        ></GridComponent>
      </div>
    </Container>
  );
}
export default DrugLiquidationOrderHistory;
